import { WebPlugin } from '@capacitor/core';
export class CapacitorIvsPlayerWeb extends WebPlugin {
    async create(options) {
        console.log('create', options);
        return;
    }
    async start() {
        console.log('start');
        return;
    }
    async pause() {
        console.log('pause');
        return;
    }
    async cast() {
        console.log('cast');
        return;
    }
    async getCastStatus() {
        console.log('getCastStatus');
        return { isActive: false };
    }
    async getUrl() {
        console.log('getUrl');
        return { url: '' };
    }
    async getState() {
        console.log('getState');
        return { state: 'UNKNOWN' };
    }
    async setPlayerPosition(options) {
        console.log('setPlayerPosition', options);
        return;
    }
    async getPlayerPosition() {
        console.log('getPlayerPosition');
        return { toBack: false };
    }
    async delete() {
        console.log('delete');
        return;
    }
    async setFrame(options) {
        console.log('setPosition', options);
        return;
    }
    async getFrame() {
        console.log('getPosition');
        return { x: 0, y: 0, width: 0, height: 0 };
    }
    async setBackgroundState(options) {
        console.log('setBackgroundState', options);
        return;
    }
    async getBackgroundState() {
        console.log('getBackgroundState');
        return { backgroundState: 'PAUSED' };
    }
    async setPip() {
        console.log('setPip');
    }
    async getPip() {
        console.log('getPip');
        return { pip: false };
    }
    async setFullscreen() {
        console.log('toggleFullscreen');
        return;
    }
    async getFullscreen() {
        console.log('getFullscreen');
        return { fullscreen: false };
    }
    async setMute() {
        console.log('toggleMute');
        return;
    }
    async getMute() {
        console.log('getMute');
        return { mute: false };
    }
    async setQuality(options) {
        console.log('setQuality', options);
        return;
    }
    async getQualities() {
        console.log('getQualities');
        return { qualities: [] };
    }
    async getQuality() {
        console.log('getQuality');
        return { quality: '' };
    }
    async setAutoQuality(options) {
        console.log('setAutoQuality', options);
        return;
    }
    async getAutoQuality() {
        console.log('getAutoQuality');
        return { autoQuality: false };
    }
    async getPluginVersion() {
        console.warn('Cannot get plugin version in web');
        return { version: 'default' };
    }
}
//# sourceMappingURL=web.js.map